module.exports = __webpack_public_path__ + "pic/36.35a807be.png";